import { render } from "./Resources.vue?vue&type=template&id=22d40982&scoped=true"
import script from "./Resources.vue?vue&type=script&lang=js"
export * from "./Resources.vue?vue&type=script&lang=js"

import "./Resources.vue?vue&type=style&index=0&id=22d40982&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d40982"]])

export default __exports__